import angular from 'angular';
import '../../shared.module';
import template from './icon.component.html';
import './icon.component.scss';

class IconController {
  $onInit() {
    this.size = this.size || 20;
  }
}

angular.module('app.shared').component('cpIcon', {
  bindings: {
    name: '@',
    size: '<'
  },
  controller: IconController,
  controllerAs: 'vm',
  template
});
